import { RecordingSource } from '../context/AudioRecorderContext/types'

interface DownloadAudioParams {
  chunks: Blob[]
  mimeType: string
  source: RecordingSource
}

export function downloadAudioFile({
  chunks,
  mimeType,
  source,
}: DownloadAudioParams): void {
  const blob = new Blob(chunks, { type: mimeType })
  const fileName = `Live ${source === RecordingSource.TAB ? 'Tab' : 'Mic'} Recording`
  const file = new File([blob], fileName, { type: blob.type })
  const url = URL.createObjectURL(file)

  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)

  URL.revokeObjectURL(url)
}
